import React, { useEffect, useState } from "react";
import api from "../../services/api";

const WebsiteApiKey = ({ websiteTechUsed, schoolId, principalName, onError }) => {
  const [apiKey, setApiKey] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const copyText = (text) => {
    navigator.clipboard.writeText(text).catch(() => setStatus("Failed to copy."));
  };

  const copyPrefilledEmail = () => {
    const body = `Dear Website Administrator,

Our School is now using the 'GhrianGhraffy App' to enhance the process of sharing our School photos with Parents.

Please update our School's website by downloading and installing the GhriahGhraffy plugin from the main WordPress plugin website located here: https://wordpress.org/plugins/

When installed, the plugin will create a new page named 'Photos' and will add the new page to the existing Menu. If our Website uses a 'Custom Menu' or a 'page builder', the plugin will create the new 'Photos' page as a 'Draft' (so that you can add the new 'Photos' page to the Menu manually).

Once the Plugin is installed and activated, two new fields ('School ID' and 'API Key') will be generated in the General Settings/Options dashboard. Here is the data that you should insert into those fields:

School ID: ${schoolId}
API Key: ${apiKey}

When you save the settings, you will see the updated Homepage of our Website with the new 'Photos' page.

Please let me know when our Website has been updated.

Kind Regards,
${principalName}`;
    copyText(body);
    setStatus("Email text copied to clipboard!");
    setTimeout(() => setStatus(""), 3000);
  };

  useEffect(() => {
    const run = async () => {
      if (websiteTechUsed === "Your School Website is not built with WordPress") {
        setApiKey(null);
        setStatus("");
        return;
      }
      setLoading(true);
      try {
        const { data } = await api.get("/auth/api-key");
        setApiKey(data.api_key);
        setStatus("");
      } catch (e) {
        if (e.response?.status === 404) {
          try {
            const res = await api.post("/auth/generate-api-key", {});
            setApiKey(res.data.api_key);
            setStatus("API key created successfully!");
          } catch (gerr) {
            console.error(gerr);
            setStatus("Failed to generate API key. Please try again or contact support.");
          }
        } else if (e.response?.status === 400) {
          setStatus("No school associated with this user.");
        } else {
          setStatus("Failed to fetch API key. Please try again or contact support.");
        }
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [websiteTechUsed]);

  if (websiteTechUsed === "Your School Website is not built with WordPress") {
    return (
      <p className="no-wordpress-message">
        It appears that your school&apos;s website was not built using WordPress. You can{" "}
        <a href="/contact" className="template-download-link">contact us</a> for integration options.
      </p>
    );
  }

  if (loading) return <p>Loading API key...</p>;

  if (!apiKey) return <p>Unable to generate API key. Please try again or contact support.</p>;

  return (
    <div className="api-key-content">
      <p>
        Copy the wording below and send to your school&apos;s IT representative:
      </p>
      <textarea
        value={`Dear Website Administrator,

Our School is now using the 'GhrianGhraffy App' to enhance the process of sharing our School photos with Parents.

Please update our School's website by downloading and installing the GhriahGhraffy plugin from the main WordPress plugin website located here: https://wordpress.org/plugins/

When installed, the plugin will create a new page named 'Photos' and will add the new page to the existing Menu. If our Website uses a 'Custom Menu' or a 'page builder', the plugin will create the new 'Photos' page as a 'Draft' (so that you can add the new 'Photos' page to the Menu manually).

Once the Plugin is installed and activated, two new fields ('School ID' and 'API Key') will be generated in the General Settings/Options dashboard. Here is the data that you should insert into those fields:

School ID: ${schoolId}
API Key: ${apiKey}

When you save the settings, you will see the updated Homepage of our Website with the new 'Photos' page.

Please let me know when our Website has been updated.

Kind Regards,
${principalName}`}
        readOnly
        style={{ width: "100%", height: 300, fontFamily: "monospace", marginTop: 10 }}
        onClick={(e) => e.target.select()}
      />
      <button
        onClick={copyPrefilledEmail}
        style={{ marginTop: 10, padding: "8px 16px", backgroundColor: "#00FFAF", color: "#0e6ebe", border: "none", cursor: "pointer" }}
      >
        Copy Email
      </button>
      {status && <p>{status}</p>}
    </div>
  );
};

export default WebsiteApiKey;

